// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"03b4408e","146":"1dfb1b89","551":"e4dc3722","693":"0f18eb86","711":"19b5bc65","886":"a9c6457f"}[chunkId] + ".css";
};